import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIModal from 'UIComponents/dialog/UIModal';
import GoToPaymentsButton from 'growth-payments-core/components/GoToPaymentsButton';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CRMModal = props => {
  const {
    screen,
    handleInterstitialModalClose
  } = props;
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 900,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "interstitial-modal-close-button",
      onClick: handleInterstitialModalClose
    }), /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-all-5",
      children: [/*#__PURE__*/_jsxs(UIBox, {
        children: [/*#__PURE__*/_jsx(UIDialogHeader, {
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "400",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h6",
              textAlign: "left",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "embedPoints.paymentsInterstitialModal.enrollInHubSpotPayments"
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "h2",
              textAlign: "left",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "embedPoints.paymentsInterstitialModal.collectPayments"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(UIDialogBody, {
          children: /*#__PURE__*/_jsxs(Text, {
            textAlign: "left",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.paymentsInterstitialModal.processAndReportPayments"
            }), /*#__PURE__*/_jsxs(List, {
              styled: true,
              children: [/*#__PURE__*/_jsx(ListItem, {
                marginBlockStart: "800",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "embedPoints.paymentsInterstitialModal.embedAPaymentLinkFromAnywhere"
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "embedPoints.paymentsInterstitialModal.acceptPayments"
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "embedPoints.paymentsInterstitialModal.increaseEfficiency"
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(UIDialogFooter, {
          children: /*#__PURE__*/_jsx(GoToPaymentsButton, {
            use: "primary",
            external: true,
            page: screen,
            location: "embed-point-pre-enroll-modal",
            block: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.paymentsInterstitialModal.goToPayments"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(UIBox, {
        alignSelf: "center",
        children: /*#__PURE__*/_jsx(UIIllustration, {
          alt: "Illustration of a computer screen with a payment link",
          name: "payments",
          width: "70%"
        })
      })]
    })]
  });
};
export default CRMModal;